<template>
    <div v-if="showUCBenefits" role="region" aria-labelledby="my-benefits-heading">
        <hp5-heading element-id="my-benefits-heading" size-selection="lg" tag-selection="h2">My benefits</hp5-heading>
        <hp5-semantic size-selection="sm">
            See what's covered by your plan
        </hp5-semantic>
        <hp5-spacing-vertical xs="xs" xl="xs" md="xs" lg="xs"></hp5-spacing-vertical>
        <div v-if="showSpecialtyUrgentCareCategories">
            <hp5-semantic size-selection="sm">
                <ul>
                    <li v-for="(benefit, index) in benefitCategories" :key="index">
                        <hp5-link-text-basic :href="buildDetailUrl(benefit.category)" :text="format(benefit.category)" size="sm"></hp5-link-text-basic>
                    </li>
                </ul>
            </hp5-semantic>
        </div>
        <div v-else>
            <hp5-semantic size-selection="sm">
                <ul>
                    <li>
                        <hp5-link-text-basic :href="buildDetailUrl(categoryTerm)" :text="format(categoryTerm)" size="sm"></hp5-link-text-basic>
                    </li>
                </ul>
            </hp5-semantic>
        </div>
        <hp5-spacing-vertical xs="md" xl="md" md="md" lg="md"></hp5-spacing-vertical>
    </div>
</template>
  
<script setup>
const { benefitCategories, isAuthenticated, context } = useFCPModel()
const showUCBenefits = computed(() => isAuthenticated.value && benefitCategories?.value?.length > 0 && (context.value.type == 'urgent') )

const { buildUrl } = useUrls(context.value)

const buildDetailUrl = (categoryTerm) => {
    return buildUrl(`/fcp/csearch/benefits/?category=${categoryTerm}`)
}


// most users only have 1 urgent care category that has detail information, EMERGENCY AND URGENT CARE,
// but the benefit service returns 3 categories, EMERGENCY AND URGENT CARE, EMERGENCY ROOM, and URGENT CARE
// even though EMERGENCY ROOM and URGENT CARE don't return any detail information
// but there are a few users that have special networks that return more than 1 viable emergency care benefit
// so figure out if we're in a special case by checking for an 'EMERGENCY ROOM' category
const showSpecialtyUrgentCareCategories = computed(() => benefitCategories?.value?.find((element) => element.category == 'EMERGENCY ROOM') ? false : true)

const format = (name) => {
    const words = name.split(' ')
    let returnString = ''

    words.forEach((w) => {
        returnString += w[0] + w.substr(1).toLowerCase() + ' '
    })
    return returnString
}

// the emergency and urgent care scenario is a little weird on the OLB service side
// normally, we pass the category given by the service call to get the details,
// but the OLB returns nothing for 'emergency room' or 'urgent care' categories
// the only terms it accepts are 'EMERGENCY AND URGENT CARE' or 'EMERGENCY AND URGENTLY NEED CARE SERVICES'
// so first we need to find the category that has that title name and select that one
// then we can pass that term (in this case, the categoryTerm, in caps) to make sure we get details back
// from the service
const foundCategory = benefitCategories?.value?.find((element) => element.category.includes('EMERGENCY AND URGENT'))
const categoryTerm = foundCategory ? foundCategory.category : 'EMERGENCY AND URGENT CARE'

</script>
